module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewreport_game"
  }, [_c('cIndex'), _vm._v(" "), _c('div', {
    staticClass: "viewreport"
  }, [_c('h4', [_vm._v("脑健康体检报告")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/duihao.png"),
      "alt": "图片"
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v(_vm._s(_vm.gameReport.name))]), _vm._v("您好，您已完成本次脑体检测试")]), _vm._v(" "), _c('li', [_vm._v("测试套餐为"), _c('span', [_vm._v(_vm._s(_vm.gameReport.tc))]), _vm._v("," + _vm._s(_vm.gameReport.nengli) + "。")]), _vm._v(" "), _c('li', [_vm._v("您的综合各项脑能力表现"), _c('span', [_vm._v(_vm._s(_vm.gameReport.renzhi))])])]), _vm._v(" "), _c('p', {
    staticClass: "viewreport-buttons"
  }, [_c('a', {
    staticClass: "reportpage-button",
    on: {
      "click": function($event) {
        _vm.reportpage(_vm.gameReport)
      }
    }
  }, [_vm._v("查看完整报告")]), _vm._v(" "), _c('b'), _vm._v(" "), _c('a', {
    staticClass: "reportpage-button button-over",
    on: {
      "click": function($event) {
        _vm.endReportpage()
      }
    }
  }, [_vm._v("结束检测")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637e2e03","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/viewreport.vue
// module id = 759
// module chunks = 1